import React from 'react';
import Box from '../../../components/Box';
import styled from 'styled-components';
import { Form, Input, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Text from '../../../components/Text';
import { SocialSourceType } from '../../../services/settingApis';

type SocialSectionItemProps = {
  active_name: string;
  url_name: string;
  type: SocialSourceType;
};

const SocialSectionItem = ({ active_name, url_name, type }: SocialSectionItemProps) => {
  const getLabel = () => {
    switch (type) {
      case SocialSourceType.GOOGLE:
        return 'Google Review';
      case SocialSourceType.FACEBOOK:
        return 'Facebook Review';
      case SocialSourceType.YELP:
        return 'Yelp Review';
      case SocialSourceType.INSTAGRAM:
        return 'Instagram Review';
      default:
        return '';
    }
  };

  return (
    <Box display='flex' gap={1}>
      <Box display='flex' gap={1} width={'50%'} alignItems='start'>
        <FormItemStyled name={active_name} label='Active'>
          <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
        </FormItemStyled>
        <div style={{ width: '100%' }}>
          <FormItemStyled label='Name'>
            <Box display='flex' gap={1} width={'100%'} alignItems='center'>
              {type === SocialSourceType.GOOGLE && (
                <img src='/images/google.jpg' alt='google' width={14} height={14} />
              )}
              {type === SocialSourceType.FACEBOOK && (
                <img src='/images/facebook.jpg' alt='facebook' width={14} height={14} />
              )}
              {type === SocialSourceType.YELP && (
                <img src='/images/yelp.png' alt='yelp' width={14} height={14} />
              )}
              {type === SocialSourceType.INSTAGRAM && (
                <img src='/images/instagram.jpg' alt='instagram' width={14} height={14} />
              )}
              <Text variant='CONTENT_1'>{getLabel()}</Text>
            </Box>
          </FormItemStyled>
        </div>
      </Box>
      <Box width={'50%'}>
        <FormItemStyled
          name={url_name}
          rules={[{ required: true, message: 'Please enter URL' }]}
          label={
            <LabelStyled>
              URL <span className='special-label'>(Required)</span>
            </LabelStyled>
          }
        >
          <Input size='large' placeholder='Enter URL' />
        </FormItemStyled>
      </Box>
    </Box>
  );
};

export default SocialSectionItem;

const FormItemStyled = styled(Form.Item)`
  margin: 0;
`;

const LabelStyled = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1d2129;
  .special-label {
    color: #008bff;
  }
`;
